var _circle, _rect, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockAdded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125,
    r: 125,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2526_53456",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 51,
    width: 140,
    height: 140
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 51,
    width: 140,
    height: 140,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2526_53456)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.5 97.6666V85.9999C142.5 81.1388 140.799 77.0069 137.396 73.6041C133.993 70.2013 129.861 68.4999 125 68.4999C120.139 68.4999 116.007 70.2013 112.604 73.6041C109.201 77.0069 107.5 81.1388 107.5 85.9999V97.6666H142.5ZM126.458 179.333H90C86.7916 179.333 84.0451 178.191 81.7604 175.906C79.4757 173.621 78.3333 170.875 78.3333 167.667V109.333C78.3333 106.125 79.4757 103.378 81.7604 101.094C84.0451 98.8089 86.7916 97.6666 90 97.6666H95.8333V85.9999C95.8333 77.9305 98.6771 71.052 104.365 65.3645C110.052 59.677 116.931 56.8333 125 56.8333C133.069 56.8333 139.948 59.677 145.635 65.3645C151.323 71.052 154.167 77.9305 154.167 85.9999V97.6666H160C163.208 97.6666 165.955 98.8089 168.24 101.094C170.524 103.378 171.667 106.125 171.667 109.333V116.917C169.722 116.236 167.778 115.774 165.833 115.531C163.889 115.288 161.944 115.167 160 115.167C148.625 115.167 138.976 119.128 131.052 127.052C123.128 134.976 119.167 144.625 119.167 156C119.167 160.18 119.823 164.24 121.135 168.177C122.448 172.115 124.222 175.833 126.458 179.333Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.559 157.363L135.934 147.568L134.868 146.483L133.798 147.564L130.156 151.244L129.116 152.295L130.152 153.35L144.488 167.94L145.558 169.029L146.628 167.94L177.403 136.62L178.436 135.569L177.403 134.518L173.787 130.838L172.718 129.749L171.648 130.837L145.559 157.363Z",
    fill: "#383838",
    stroke: "#383838",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockAdded);
export default __webpack_public_path__ + "static/media/lockAdded.d89e66abfd029c61b6e9870a81cd59fb.svg";
export { ForwardRef as ReactComponent };